import { Stack } from '@mui/system'
import React from 'react'
import { Link } from 'react-router-dom'
import { logo } from '../../utils/Constants'
import SearchBar from './SearchBar'


const Navbar = () => {
  return (
    <div>
      <Stack direction="row" alignItems="center" p={2} sx={{ width:"100%",position: "sticky", background: "#000", top: 0, justifyContent: "space-between"}}>
        <Link to="/">
          <img src={logo} alt="" className='w-[6vh] md:w-[15%]' />
        </Link>
        <SearchBar/>
      </Stack>
    </div>
  )
}

export default Navbar
